/**
 * B080010 出荷予定作成
 */
import {
  B000111DenpyoshubetsuNm,
  B000130BumonNmFrom,
  B000130BumonNmTo,
  B000140ShainNmFrom,
  B000140ShainNmTo,
  B000151NonyuNmFrom,
  B000151NonyuNmTo,
  B000150TokuiNmFrom,
  B000150TokuiNmTo,
  B080010Create,
  B080010CreateRequest,
  B080010Find,
  B080010FindRequest,
  B080010FindResponse,
  B080010JuchudenpyoNo,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SConfirmDialog,
  SDateField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import {
  getSCode,
  HasokbnCd,
  HasosakiCd,
  NetsukeKbn,
  PpgakeKbn,
  SCode,
  ShohinshubetsuKbn,
} from "messages/codes";
import { labels } from "messages/labels";
import { B000111, B000130, B000140, B000150, B000151 } from "pages";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { date } from "services";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  shukashijiYmd: string;
  shukaYmdFrom: string;
  shukaYmdTo: string;
  hasokbnCd: SCode;
  hasosakiCd: SCode;
  shohinshubetsuKbn: SCode;
  bumonCdFrom: string;
  bumonNmFrom: string;
  bumonCdTo: string;
  bumonNmTo: string;
  shainCdFrom: string;
  shainNmFrom: string;
  shainCdTo: string;
  shainNmTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCdFrom: string;
  tokuishitenCdFrom: string;
  tokuiNmFrom: string;
  tokuiCdTo: string;
  tokuishitenCdTo: string;
  tokuiNmTo: string;
  nonyuCdFrom: string;
  nonyushitenCdFrom: string;
  nonyuNmFrom: string;
  nonyuCdTo: string;
  nonyushitenCdTo: string;
  nonyuNmTo: string;
  denpyoshubetsuCd: string;
  denpyoshubetsuNm: string;
  ppgakeKbn: SCode;
  netsukeKbn: SCode;
  shukakanoukensu: string;
  honjitsuizenkensu: string;
  asitakensu: string;
  asatteikokensu: string;
  taisyoshukakensu: string;
  juchudenpyoNoList: B080010JuchudenpyoNo[];
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  shukashijiYmd: date(),
  shukaYmdFrom: date(),
  shukaYmdTo: date(),
  hasokbnCd: null,
  hasosakiCd: null,
  shohinshubetsuKbn: getSCode(ShohinshubetsuKbn, "0"),
  bumonCdFrom: "",
  bumonNmFrom: "",
  bumonCdTo: "",
  bumonNmTo: "",
  shainCdFrom: "",
  shainNmFrom: "",
  shainCdTo: "",
  shainNmTo: "",
  juchudenpyoNoFrom: "",
  juchudenpyoNoTo: "",
  tokuiCdFrom: "",
  tokuishitenCdFrom: "",
  tokuiNmFrom: "",
  tokuishitenCdTo: "",
  tokuiNmTo: "",
  nonyuCdFrom: "",
  nonyushitenCdFrom: "",
  nonyuNmFrom: "",
  nonyuCdTo: "",
  nonyushitenCdTo: "",
  nonyuNmTo: "",
  denpyoshubetsuCd: "",
  denpyoshubetsuNm: "",
  // 初期空白
  ppgakeKbn: getSCode(PpgakeKbn, ""),
  netsukeKbn: getSCode(NetsukeKbn, ""),
  shukakanoukensu: "",
  honjitsuizenkensu: "",
  asitakensu: "",
  asatteikokensu: "",
  taisyoshukakensu: "",
  juchudenpyoNoList: undefined,
};

const focusId = "B080010";

// B080010 出荷予定作成
export const B080010 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
    //
  });

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  });

  // ボタンの活性・非活性
  const [disabledExecute, setDisabledExecute] = useState(true);

  // メッセージ表示
  const setMsg = useSetRecoilState(msgState);

  // 画面遷移
  const navigate = useNavigate();

  // 検索ボタンクリックイベント
  const handleClickSearchButtun = () => {
    return new Promise<any>(() => {
      // リクエスト作成
      // 検索フォームのデータを取得する。
      const fields = methods.getValues();
      // 検索クリックイベント
      const param: B080010FindRequest = {
        shukaYmdFrom: fields.shukaYmdFrom!,
        shukaYmdTo: fields.shukaYmdTo,
        hasokbnCd: fields.hasokbnCd?.value!,
        hasosakiCd: fields.hasosakiCd?.value,
        shohinshubetsuKbn: fields.shohinshubetsuKbn?.value!,
        bumonCdFrom: fields.bumonCdFrom,
        bumonCdTo: fields.bumonCdTo,
        shainCdFrom: fields.shainCdFrom,
        shainCdTo: fields.shainCdTo,
        juchudenpyoNoFrom: fields.juchudenpyoNoFrom,
        juchudenpyoNoTo: fields.juchudenpyoNoTo,
        tokuiCdFrom: fields.tokuiCdFrom,
        tokuishitenCdFrom: fields.tokuishitenCdFrom,
        tokuiCdTo: fields.tokuiCdTo,
        tokuishitenCdTo: fields.tokuishitenCdTo,
        nonyuCdFrom: fields.nonyuCdFrom,
        nonyushitenCdFrom: fields.nonyushitenCdFrom,
        nonyuCdTo: fields.nonyuCdTo,
        nonyushitenCdTo: fields.nonyushitenCdTo,
        denpyoshubetsuCd: fields.denpyoshubetsuCd,
        ppgakeKbn: fields.ppgakeKbn?.value,
        netsukeKbn: fields.netsukeKbn?.value,
      };
      // API呼び出し
      B080010Find(param)
        // 正常取得時
        .then((value) => {
          // 件数の設定
          handleKensu(value.data);
        })
        // エラー時
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
          // エラー時は件数をクリアする。
          methods.setValue("shukakanoukensu", "");
          methods.setValue("honjitsuizenkensu", "");
          methods.setValue("asitakensu", "");
          methods.setValue("asatteikokensu", "");
          methods.setValue("taisyoshukakensu", "");
          methods.setValue("juchudenpyoNoList", undefined);
          // ボタン非活性化
          setDisabledExecute(true);
        });
    });
  };

  // 件数の設定
  const handleKensu = (data: B080010FindResponse) => {
    // 検索結果のチェック
    if (Number(data.taisyoshukakensu) <= 0) {
      // 件数の設定
      methods.setValue("shukakanoukensu", data.shukakanoukensu);
      methods.setValue("honjitsuizenkensu", data.honjitsuizenkensu);
      methods.setValue("asitakensu", data.asitakensu);
      methods.setValue("asatteikokensu", data.asatteikokensu);
      methods.setValue("taisyoshukakensu", data.taisyoshukakensu);
      methods.setValue("juchudenpyoNoList", data.juchudenpyoNoList);
      setMsg("対象出荷件数が0件です。");
      // ボタン非活性化
      setDisabledExecute(true);
    }
    // 結果が1件以上取得できた場合
    else {
      // 件数の設定
      methods.setValue("shukakanoukensu", data.shukakanoukensu);
      methods.setValue("honjitsuizenkensu", data.honjitsuizenkensu);
      methods.setValue("asitakensu", data.asitakensu);
      methods.setValue("asatteikokensu", data.asatteikokensu);
      methods.setValue("taisyoshukakensu", data.taisyoshukakensu);
      methods.setValue("juchudenpyoNoList", data.juchudenpyoNoList);

      // ボタン活性化
      setDisabledExecute(false);
    }
  };

  // 実行イベント
  const handleExecute = () => {
    const data = methods.getValues();
    // パラメータ作成
    if (data.juchudenpyoNoList !== undefined) {
      const param: B080010CreateRequest = {
        shukashijiYmd: data.shukashijiYmd!,
        juchudenpyoNoList: data.juchudenpyoNoList,
      };

      // 実行API呼び出し
      B080010Create(param)
        .then(() => {
          setMsg(getClientMessage("B080010_001"));
          // 再検索
          handleClickSearchButtun();
        })
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
        });
    }
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="出荷予定作成"
        gridTemplateColumns="6rem 8rem 6rem 1rem 10rem 1rem 8rem 6rem 10rem"
      >
        <SLabel>出荷指示日</SLabel>
        <SDateField
          name="shukashijiYmd"
          gridColumn="span 2"
          disabled
          required
          label="出荷指示日"
        />
        <SLabel gridColumn="1" required>
          出荷日
        </SLabel>
        <SDateField
          name="shukaYmdFrom"
          {...register(1)}
          gridColumn="span 2"
          required
          label="出荷日(開始)"
        />
        <SText>～</SText>
        <SDateField name="shukaYmdTo" {...register(2)} />
        <SText gridColumn="1">　</SText>
        <SLabel gridColumn="1">発送区分</SLabel>
        <SCodeSelect
          name="hasokbnCd"
          options={HasokbnCd}
          {...register(3)}
          gridColumn="span 2"
          empty
          label="発送区分"
        />
        <SLabel gridColumn="1">発送先</SLabel>
        <SCodeSelect
          name="hasosakiCd"
          options={HasosakiCd}
          {...register(4)}
          gridColumn="span 2"
          empty
          label="発送先"
        />
        <SLabel gridColumn="1">商品種別</SLabel>
        <SCodeSelect
          name="shohinshubetsuKbn"
          options={ShohinshubetsuKbn}
          {...register(5)}
          gridColumn="span 2"
          empty
        />
        <SText gridColumn="1">　</SText>
        <SLabel gridColumn="1">受注担当部門</SLabel>
        <SNumberField
          name="bumonCdFrom"
          code
          size={6}
          onBlur={() => B000130BumonNmFrom(methods, navigate, setMsg)}
          {...register(6)}
          gridColumn="span 2"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdFrom", data.bumonCd);
            methods.setValue("bumonNmFrom", data.bumonNmr);
          }}
        />
        <STextField name="bumonNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="bumonCdTo"
          code
          size={6}
          onBlur={() => B000130BumonNmTo(methods, navigate, setMsg)}
          {...register(7)}
          gridColumn="span 2"
          dialog={<B000130 />}
          handleSubmit={(data: any) => {
            methods.setValue("bumonCdTo", data.bumonCd);
            methods.setValue("bumonNmTo", data.bumonNmr);
          }}
        />
        <STextField name="bumonNmTo" size={40} disabled />
        <SLabel gridColumn="1">受注担当者</SLabel>
        <SNumberField
          name="shainCdFrom"
          code
          size={7}
          onBlur={() => B000140ShainNmFrom(methods, navigate, setMsg)}
          {...register(8)}
          gridColumn="span 2"
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdFrom", data.shainCd);
            methods.setValue("shainNmFrom", data.shainNm);
          }}
        />
        <STextField name="shainNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="shainCdTo"
          code
          size={7}
          onBlur={() => B000140ShainNmTo(methods, navigate, setMsg)}
          {...register(9)}
          gridColumn="span 2"
          dialog={<B000140 />}
          handleSubmit={(data: any) => {
            methods.setValue("shainCdTo", data.shainCd);
            methods.setValue("shainNmTo", data.shainNm);
          }}
        />
        <STextField name="shainNmTo" size={40} disabled />
        <SLabel gridColumn="1">受注番号</SLabel>
        <SNumberField
          name="juchudenpyoNoFrom"
          code
          size={10}
          {...register(10)}
          gridColumn="span 2"
        />
        <SText>～</SText>
        <SNumberField name="juchudenpyoNoTo" code size={10} {...register(11)} />
        <SText gridColumn="1">　</SText>
        <SLabel gridColumn="1">得意先</SLabel>
        <SNumberField
          name="tokuiCdFrom"
          code
          size={6}
          onBlur={() => B000150TokuiNmFrom(methods, navigate, setMsg)}
          {...register(12)}
        />
        <SNumberField
          name="tokuishitenCdFrom"
          code
          size={4}
          onBlur={() => B000150TokuiNmFrom(methods, navigate, setMsg)}
          {...register(13)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCdFrom", data.tokuiCd);
            methods.setValue("tokuishitenCdFrom", data.tokuishitenCd);
            methods.setValue("tokuiNmFrom", data.tokuiNmr);
          }}
        />
        <STextField name="tokuiNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="tokuiCdTo"
          code
          size={6}
          onBlur={() => B000150TokuiNmTo(methods, navigate, setMsg)}
          {...register(14)}
        />
        <SNumberField
          name="tokuishitenCdTo"
          code
          size={4}
          onBlur={() => B000150TokuiNmTo(methods, navigate, setMsg)}
          {...register(15)}
          dialog={<B000150 />}
          handleSubmit={(data: any) => {
            methods.setValue("tokuiCdTo", data.tokuiCd);
            methods.setValue("tokuishitenCdTo", data.tokuishitenCd);
            methods.setValue("tokuiNmTo", data.tokuiNmr);
          }}
        />
        <STextField name="tokuiNmTo" size={40} disabled />
        <SLabel gridColumn="1">納入先</SLabel>
        <SNumberField
          name="nonyuCdFrom"
          code
          size={6}
          onBlur={() => B000151NonyuNmFrom(methods, navigate, setMsg)}
          {...register(16)}
        />
        <SNumberField
          name="nonyushitenCdFrom"
          code
          size={4}
          onBlur={() => B000151NonyuNmFrom(methods, navigate, setMsg)}
          {...register(17)}
          dialog={<B000151 />}
          handleSubmit={(data: any) => {
            methods.setValue("nonyuCdFrom", data.nonyuCd);
            methods.setValue("nonyushitenCdFrom", data.nonyushitenCd);
            methods.setValue("nonyuNmFrom", data.tokuiNmr);
          }}
        />
        <STextField name="nonyuNmFrom" size={40} disabled gridColumn="span 2" />
        <SText>～</SText>
        <SNumberField
          name="nonyuCdTo"
          code
          size={6}
          onBlur={() => B000151NonyuNmTo(methods, navigate, setMsg)}
          {...register(18)}
        />
        <SNumberField
          name="nonyushitenCdTo"
          code
          size={4}
          onBlur={() => B000151NonyuNmTo(methods, navigate, setMsg)}
          {...register(19)}
          dialog={<B000151 />}
          handleSubmit={(data: any) => {
            methods.setValue("nonyuCdTo", data.nonyuCd);
            methods.setValue("nonyushitenCdTo", data.nonyushitenCd);
            methods.setValue("nonyuNmTo", data.tokuiNmr);
          }}
        />
        <STextField name="nonyuNmTo" size={40} disabled />
        <SLabel gridColumn="1">伝票種別</SLabel>
        <SNumberField
          name="denpyoshubetsuCd"
          code
          size={3}
          onBlur={() => B000111DenpyoshubetsuNm(methods, navigate, setMsg)}
          {...register(20)}
          gridColumn="span 2"
          dialog={<B000111 meishoKbn={"33"} />}
          handleSubmit={(data: any) => {
            methods.setValue("denpyoshubetsuCd", data.meishoCd);
            methods.setValue("denpyoshubetsuNm", data.meishoNm1);
          }}
        />
        <STextField
          name="denpyoshubetsuNm"
          size={40}
          disabled
          gridColumn="span 2"
        />
        <SLabel gridColumn="1">PP掛け</SLabel>
        <SCodeSelect
          name="ppgakeKbn"
          options={PpgakeKbn}
          {...register(21)}
          gridColumn="span 2"
          empty
        />
        <SLabel gridColumn="1">値付け</SLabel>
        <SCodeSelect
          name="netsukeKbn"
          options={NetsukeKbn}
          {...register(22)}
          gridColumn="span 2"
          empty
        />
        <SNormalButton
          label={labels.buttons.search}
          gridRow={17}
          gridColumn={9}
          {...register(23)}
          onClick={handleClickSearchButtun}
          align="right"
        />
      </SFrame>
      <SFrame gridTemplateColumns="8rem 1rem 1rem 8rem 1rem 1rem 8rem 1rem 1rem 8rem 1rem 1rem 8rem 1rem 6.5rem">
        <SLabel gridColumn="span 2">出荷可能件数</SLabel>
        <SText></SText>
        <SLabel gridColumn="span 2">本日以前件数</SLabel>
        <SText></SText>
        <SLabel gridColumn="span 2">明日件数</SLabel>
        <SText></SText>
        <SLabel gridColumn="span 2">明後日以降件数</SLabel>
        <SText></SText>
        <SLabel gridColumn="span 2">対象出荷件数</SLabel>
        <SText></SText>
        <SNumberField
          name="shukakanoukensu"
          size={6}
          {...register(20)}
          align="right"
          disabled
          gridColumn={1}
        />
        <SText align="center" bordered>
          件
        </SText>
        <SText></SText>
        <SNumberField
          name="honjitsuizenkensu"
          size={6}
          {...register(20)}
          align="right"
          disabled
        />
        <SText align="center" bordered>
          件
        </SText>
        <SText></SText>
        <SNumberField
          name="asitakensu"
          size={6}
          {...register(20)}
          align="right"
          disabled
        />
        <SText align="center" bordered>
          件
        </SText>
        <SText></SText>
        <SNumberField
          name="asatteikokensu"
          size={6}
          {...register(20)}
          align="right"
          disabled
        />
        <SText align="center" bordered>
          件
        </SText>
        <SText></SText>
        <SNumberField
          name="taisyoshukakensu"
          size={6}
          {...register(20)}
          align="right"
          disabled
        />
        <SText align="center" bordered>
          件
        </SText>
        <SText></SText>
        <SNormalButton
          label={labels.buttons.execute}
          disabled={disabledExecute}
          gridRow={3}
          gridColumn={15}
          align="right"
          {...register(23)}
          dialog={
            <SConfirmDialog
              title="出荷予定ファイル出力"
              msg="出力します。よろしいですか？"
            />
          }
          dialogAction="confirm"
          handleSubmit={handleExecute}
        />
      </SFrame>
    </FormProvider>
  );
};
